import React from "react";
import Seo from "components/Seo";
import CompanyLayout from "./companyLayout";
import Branch from "../../../common/-pages/company/branch";

const MorningBranch = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="지사소개" />
            <CompanyLayout>
                <Branch />
            </CompanyLayout>
        </React.Fragment>
    );
};

export default MorningBranch;
